import styled from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => `margin-bottom: ${theme.space[6]}`};
`;
